import { motion } from "framer-motion";
import { User, Mail, Globe } from "lucide-react";

export default function Step1BasicInfo({ formData, setFormData, errors }) {
  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{ duration: 0.3 }}
      className="p-6 bg-white rounded-xl border border-gray-200 shadow-sm sm:p-8"
    >
      <div className="flex gap-3 items-center mb-8">
        <div className="flex justify-center items-center w-10 h-10 text-white bg-gradient-to-br from-orange-500 to-orange-600 rounded-lg shadow-md">
          <User size={20} />
        </div>
        <h2 className="text-2xl font-bold text-gray-900">Basic Information</h2>
      </div>
      <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
        <div>
          <label className="flex gap-2 items-center mb-2 text-sm font-semibold text-gray-700">
            <User size={16} className="text-orange-600" />
            First Name (as per passport) <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            value={formData.firstName || ""}
            onChange={(e) => handleChange("firstName", e.target.value)}
            className={`w-full px-4 py-3 text-gray-900 bg-white rounded-lg border transition-all outline-none focus:ring-2 focus:ring-orange-500 focus:border-orange-500 ${
              errors?.firstName ? "border-red-300 bg-red-50" : "border-gray-300 hover:border-gray-400"
            }`}
            placeholder="Enter first name"
          />
          {errors?.firstName && <p className="mt-1 text-sm text-red-500">{errors.firstName}</p>}
        </div>
        <div>
          <label className="flex gap-2 items-center mb-2 text-sm font-semibold text-gray-700">
            <User size={16} className="text-orange-600" />
            Last Name (as per passport) <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            value={formData.lastName || ""}
            onChange={(e) => handleChange("lastName", e.target.value)}
            className={`w-full px-4 py-3 text-gray-900 bg-white rounded-lg border transition-all outline-none focus:ring-2 focus:ring-orange-500 focus:border-orange-500 ${
              errors?.lastName ? "border-red-300 bg-red-50" : "border-gray-300 hover:border-gray-400"
            }`}
            placeholder="Enter last name"
          />
          {errors?.lastName && <p className="mt-1 text-sm text-red-500">{errors.lastName}</p>}
        </div>
        <div>
          <label className="flex gap-2 items-center mb-2 text-sm font-semibold text-gray-700">
            <Globe size={16} className="text-orange-600" />
            Nationality <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            value={formData.nationality || ""}
            onChange={(e) => handleChange("nationality", e.target.value)}
            className={`w-full px-4 py-3 text-gray-900 bg-white rounded-lg border transition-all outline-none focus:ring-2 focus:ring-orange-500 focus:border-orange-500 ${
              errors?.nationality ? "border-red-300 bg-red-50" : "border-gray-300 hover:border-gray-400"
            }`}
            placeholder="Enter nationality"
          />
          {errors?.nationality && <p className="mt-1 text-sm text-red-500">{errors.nationality}</p>}
        </div>
        <div>
          <label className="flex gap-2 items-center mb-2 text-sm font-semibold text-gray-700">
            <Mail size={16} className="text-orange-600" />
            Email Address <span className="text-red-500">*</span>
          </label>
          <input
            type="email"
            value={formData.email || ""}
            onChange={(e) => handleChange("email", e.target.value)}
            className={`w-full px-4 py-3 text-gray-900 bg-white rounded-lg border transition-all outline-none focus:ring-2 focus:ring-orange-500 focus:border-orange-500 ${
              errors?.email ? "border-red-300 bg-red-50" : "border-gray-300 hover:border-gray-400"
            }`}
            placeholder="your.email@example.com"
          />
          {errors?.email && <p className="mt-1 text-sm text-red-500">{errors.email}</p>}
        </div>
      </div>
    </motion.div>
  );
}
